(ns manage.column-classification-table.db
  (:require [common.db.table.backend :refer [map->InMemoryBackend]]
            [common.db.table.core :refer [register-table]]))

(def backend
  (map->InMemoryBackend {}))

(register-table
 {:namespace :table.column-classification
  :value-sub [:form.content-variant/fields]
  :initial-page {}
  :initial-search {}
  :initial-sort {}
  :backend backend})
